
import React, { useEffect, useState, useRef } from 'react';
import './notFound.css'
import sadcompiuter from './../../assets/images/sadcompiuter.jpg'

function NotFound() {






    return (

        <div id="back404">
            <img src={sadcompiuter} />
            <p> صفحه پیدا نشد !</p>
            <p style={{direction:'ltr'}}>404 ERROR</p>
        </div>
    )

}
export default NotFound;

